export const validation = {
  facebook: "Please enter facebook link",
  twitter: "Please enter twitter link",
  instagram: "Please enter instagram link",
  linkedin: "Please enter linkedin link",
  validLink: "Please enter valid link",
};
